import { render, staticRenderFns } from "./LoaderImg.vue?vue&type=template&id=08c08c57"
import script from "./LoaderImg.vue?vue&type=script&lang=js"
export * from "./LoaderImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports